module.exports = "<!-- <app-home></app-home> -->\r\n<app-stuhome></app-stuhome>"